import Link          from "next/link";
import { useRouter } from "next/router";
import React         from "react";

import { useGetDeviceType } from "_common/hooks/global";
import { shortenNumber }    from "_common/utils";
import { PrimaryButton }    from "_components/atoms/button";
import Divider              from "_components/atoms/divider/index.js";
import Icon                 from "_components/atoms/icon";
import Image                from "_components/atoms/image";
import Typography           from "_components/atoms/typography";
import FollowUser           from "_components/molecules/followUser";

import useStyles from "./styles.js";

const component = ( { topProfileData, isLoggedIn, myProfile } ) => {
	const {

		followers,
		id,
		isCeleb,
		isFollowing,
		isLive,
		name,
		photo,
		shortBio
	}     = topProfileData;

	const { classes } = useStyles ( undefined, { name: "styles" } );

	const checkOwnProfile = () => {
		return id == myProfile?.id;
	};
	const isOwnProfile    = checkOwnProfile ();
	const router          = useRouter ();
	const href            = isLive ? `/profile/${ id }?play_recent=${ true }` : `/profile/${ id }`;

	const deviceType = useGetDeviceType ();
	const isMobile   = deviceType === "mobile";

	const profileImage = (
		<div
			className = { classes.avatarContainer }
			onClick   = { () => router.push ( href ) }
		>
			<Image
				alt       = "profile-pic"
				className = { isLive ? classes.imageBannerActive : classes.imageBanner }
				src       = { photo }
			/>

			{
				isLive ? (
					<div className = { classes.liveButton }>
						<span className = { classes.liveText }>LIVE</span>
					</div>
				) : null
			}
		</div>
	);

	const followBtn = (
		( !isLoggedIn || !isOwnProfile ) && (
			<FollowUser
				followComponent   = { (
					<PrimaryButton
						className = { classes.followButton }
						size      = "small"
						title     = { "+ Follow" }
					/>
				) }
				isFollowing       = { isFollowing }
				unfollowComponent = { (

					<PrimaryButton
						active
						size  = "small"
						title = { "Following" }
					/>
				) }
				userId            = { Number ( id ) }
				userName          = { name }
			/>
		)
	);

	const shortBioText = (
		<Typography
			className = { classes.bio }
			title     = { shortBio }
		/>
	);

	const creatorName = (
		<div style = { {
			display    : "flex",
			alignItems : "center",
			width      : "100%"
		} }
		>

			<Link href = { `/profile/${ id }` }
				style     = { {
					width   : "inherit",
					display : "flex"
				} }
			>
				<Typography
					noWrap
					truncate
					className = { classes.name }
					title     = { name }
				/>

				{isCeleb === 1 && (
					<Icon sameInBothTheme
						className = { classes.verifiedIcon }
						name      = "verifiedProfile"
					/>
				)}
			</Link>

		</div>
	);

	const followersInfo = (
		<Typography
			className = { classes.followerCountNumber }
			color     = "secondary"
			title     = { shortenNumber ( followers ) + " " + "Followers" }
		/>
	);

	if ( isMobile ) {
		return (
			<>
				<div className = { classes.mobileContainer }>
					<div className = { classes.userInfoContainer }>

						<div className = { classes.profileAndInfoContainer }>

							{profileImage}

							<div className = { classes.mobileCreatorNameAndFollowerInfo }>
								{creatorName}

								{followersInfo}

							</div>
						</div>

						{followBtn}
					</div>

					{shortBioText}
				</div>

				<Divider />

			</>
		);
	}

	return (
		<>

			<div className = { classes.topProfileContainer }>

				{profileImage}

				<div className = { classes.infoContainer }>
					<div className = { classes.infoBtnContainer }>
						{creatorName}

						{ followBtn }
					</div>

					<div className = { classes.followersInfoContainer }>
						{followersInfo}
					</div>

					{shortBioText}
				</div>
			</div>

			<Divider />
		</>
	);
};

export default component;
